var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$root.isSmLoading)?_c('div',{staticClass:"home-index page-index"},[_c('ContentTop'),_c('div',{staticClass:"row home-content"},[_c('HomeMain',{attrs:{"switch_status":_vm.timetable_switch_status},on:{"clickSwitch":_vm.clickSwitch}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }